// 📄 components/common/FavoriteStar.tsx
// Estrella de favorito, siempre visible (no solo al hover). Recibe el
// estado y el toggle como props en vez de leer Firestore ella misma — el
// padre (HomeCard, vía useFavorites) es quien posee el estado compartido
// por página, así varias estrellas del mismo item quedan sincronizadas.
import React, { useState } from 'react';
import { Star } from 'lucide-react';

interface FavoriteStarProps {
  active: boolean;
  onToggle: () => void | Promise<void>;
  className?: string;
}

export default function FavoriteStar({ active, onToggle, className = '' }: FavoriteStarProps) {
  const [pending, setPending] = useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    // La estrella vive dentro de una card clickeable (navega) — no debe
    // disparar esa navegación al togglear.
    e.stopPropagation();
    if (pending) return;
    setPending(true);
    try {
      await onToggle();
    } finally {
      setPending(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={pending}
      title={active ? 'Quitar de favoritos' : 'Agregar a favoritos'}
      aria-pressed={active}
      aria-label={active ? 'Quitar de favoritos' : 'Agregar a favoritos'}
      className={`p-1.5 rounded-full hover:bg-white/10 transition-colors disabled:opacity-50 ${className}`}
    >
      <Star className={`w-4 h-4 transition-colors ${active ? 'fill-amber-400 text-amber-400' : 'text-gray-500'}`} />
    </button>
  );
}
